module.exports = __webpack_public_path__ + "img/caravaggio.d399e3cb.png";